import React, { useEffect, useState } from 'react';
import searchResource from '../../../locales/th/search.json';
import {
  ClearFilterButton,
  CloseButton,
  FooterButton,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  PriceInputWrapper,
  PropertyInputWrapper,
} from './MobileFilterModal.style';
import PriceInputFilter from './PriceInputFilter';
import PropertyTypeInputFilter from './PropertyTypeInputFilter';
import { PropertyType } from '../../../common/helpers/domain/propertyTypes';

interface Props {
  minPrice: number;
  maxPrice: number;
  propertyType: PropertyType;
  onConfirmSelection: (
    minPrice: number,
    maxPrice: number,
    propertyType: PropertyType,
  ) => void;
  closeModal: () => void;
  isModalOpen: boolean;
}

const MobileFilterModal: React.FC<Props> = ({
  maxPrice,
  minPrice,
  propertyType,
  onConfirmSelection,
  closeModal,
  isModalOpen,
}) => {
  const [minPriceToUpdate, setMinPriceToUpdate] = useState(minPrice);
  const [maxPriceToUpdate, setMaxPriceToUpdate] = useState(maxPrice);
  const [propertyTypeToUpdate, setPropertyTypeToUpdate] =
    useState(propertyType);

  const clearFilter = () => {
    setMinPriceToUpdate(undefined);
    setMaxPriceToUpdate(undefined);
    setPropertyTypeToUpdate(undefined);
  };

  useEffect(() => {
    setMinPriceToUpdate(minPrice);
    setMaxPriceToUpdate(maxPrice);
    setPropertyTypeToUpdate(propertyType);
  }, [minPrice, maxPrice, propertyType]);

  const onCloseModal = () => {
    setMinPriceToUpdate(minPrice);
    setMaxPriceToUpdate(maxPrice);
    setPropertyTypeToUpdate(propertyType);
    closeModal();
  };

  const isAnyFilterOptionSelected =
    minPriceToUpdate || maxPriceToUpdate || propertyTypeToUpdate;

  return (
    <Modal visible={isModalOpen}>
      <ModalHeader>
        <ClearFilterButton
          onClick={() => {
            if (isAnyFilterOptionSelected) {
              clearFilter();
            }
          }}
          isActive={!!isAnyFilterOptionSelected}
        >
          {searchResource.searchFilter.mobileClearFilter}
        </ClearFilterButton>
        <CloseButton onClick={onCloseModal}>✕</CloseButton>
      </ModalHeader>
      <ModalBody>
        <PropertyInputWrapper>
          <PropertyTypeInputFilter
            currentProperty={propertyTypeToUpdate ?? 'any'}
            onChange={(key) => setPropertyTypeToUpdate(key)}
          />
        </PropertyInputWrapper>
        <PriceInputWrapper>
          <PriceInputFilter
            maxPrice={maxPriceToUpdate}
            minPrice={minPriceToUpdate}
            onMaxPriceChange={(price) => setMaxPriceToUpdate(price)}
            onMinPriceChange={(price) => setMinPriceToUpdate(price)}
          />
        </PriceInputWrapper>
      </ModalBody>
      <ModalFooter>
        <FooterButton
          onClick={() => {
            closeModal();
            onConfirmSelection(
              minPriceToUpdate,
              maxPriceToUpdate,
              propertyTypeToUpdate,
            );
          }}
        >
          {searchResource.searchFilter.mobileFilterButton}
        </FooterButton>
      </ModalFooter>
    </Modal>
  );
};

export default MobileFilterModal;
